export const DOMAIN_PATH = '/profile';

export const Routes = {
  ROOT: DOMAIN_PATH,
  EDIT_PROFILE: `${DOMAIN_PATH}/edit`,
};
